// const directivesPromises = import.meta.glob('./*.js')
import nl2br from './nl2br'

const loadDirectives = async function(app) {

  app.directive('nl2br', nl2br)
  return app
  //
  // let files = await Promise.all(Object.keys(directivesPromises)
  //     .filter(file => file.indexOf('index.js') === -1)
  //     .map(file => directivesPromises[file]()
  //   )
  // )
  //
  // files.forEach(file => {
  //   console.log(file)
  //   app.directive('nl2br', file)
  // })
  //
  // return app

}

export default loadDirectives

